var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-picker',{ref:"picker",attrs:{"confirmTxt":_vm.confirmTxt,"cancelTxt":_vm.cancelTxt,"data":_vm.pickerData,"selectedIndex":_vm.selectedIndex},on:{"change":_vm.change,"select":_vm.select}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee0680f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./build/loaders/resource-error-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DistrictPicker/DistrictPicker.vue
// module id = null
// module chunks = 